import initStore from './initStore';
import thunks from './thunks';
import actions from './actions';
import { ICrisisModel } from './types';

const crisis: ICrisisModel = {
  ...initStore,
  ...thunks,
  ...actions,
};

export default crisis;
